import { FinancialPlanning } from './FinancialPlanning';

export type RegisterFormRadioSelect =
  | 'gender'
  | 'maritalStatus'
  | 'maritalRegime'
  | 'hasDependents';

export type RegisterFormType = Pick<
  FinancialPlanning,
  'gender' | 'maritalStatus' | 'maritalRegime'
> & {
  hasDependents: 'true' | 'false';
  dependents?: Dependents[];
  spouse: Spouse;
};

export type Dependents = Pick<
  FinancialPlanning,
  'name' | 'gender' | 'birthDate'
> & {
  kinship: keyof typeof KINSHIP | '';
};

export type Spouse = Pick<
  FinancialPlanning,
  'name' | 'gender' | 'document' | 'birthDate' | 'email'
> & {
  phoneNumber: string;
};

export enum KINSHIP {
  'CHILD' = 'Filho(a)',
  'MOTHER' = 'Mãe',
  'FATHER' = 'Pai',
  'SIBLING' = 'Irmã(o)',
  'GRANDPARENT' = 'Avô(ó)',
  'GRANDCHILD' = 'Neto(a)',
  'NEPHEW' = 'Sobrinho(a)',
  'AUNT_UNCLE' = 'Tio(a)',
  'OTHER' = 'Outro',
}

export const REGISTER_FORM_FACTORY = {
  gender: undefined,
  maritalStatus: undefined,
  maritalRegime: undefined,
  spouse: undefined,
  hasDependents: undefined,
  dependents: [
    {
      name: '',
      gender: '',
      birthDate: NaN,
      kinship: '',
    } as Dependents,
  ],
};

export type RegisterFormQuestion = {
  id: keyof RegisterFormType;
  text: string;
} & (
  | {
      options: {
        name: string;
        value: string;
      }[];
      fields?: never;
    }
  | {
      options?: never;
      fields: RegisterFormFields[];
    }
);

export type RegisterFormFields = {
  id: keyof Dependents | keyof Spouse;
  label: string;
} & (
  | {
      type: 'select';
      options: {
        name: string;
        value: string;
      }[];
    }
  | {
      type: 'text' | 'number' | 'date';
      options?: never;
    }
);
